import * as React from 'react'
import * as ReactStrap from 'reactstrap'
import * as Types from '../types'
import { TopicPreferencesLayoutAttributes } from '../constants'
import { getConfiguration } from '../../utils'

interface TopicsSettingsProps extends Types.WrappedState {
  onChange: (key: string, value: any) => void
  communityTopics: any[]
  onTopicAdd: (topic: string) => void
  onTopicRemove: (topicId: number) => void
}

interface TopicsSettingsState {
  newTopicName: string
}

export class TopicsSettings extends React.Component<TopicsSettingsProps, TopicsSettingsState> {
  constructor(props: TopicsSettingsProps) {
    super(props)
    this.state = {
      newTopicName: ''
    }
  }

  private getEnableCustomTopics = (): boolean => {
    return getConfiguration(this.props.data, TopicPreferencesLayoutAttributes.EnableCustomTopics, true)
  }

  private handleAddTopic = () => {
    const { newTopicName } = this.state
    if (newTopicName.trim()) {
      this.props.onTopicAdd(newTopicName.trim())
      this.setState({ newTopicName: '' })
    }
  }

  private handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      this.handleAddTopic()
    }
  }

  render() {
    const { communityTopics = [] } = this.props
    const { newTopicName } = this.state

    return (
      <div>
        <div className="section">
          <div className="block">
            <div className="title">Allow Custom Topics</div>
            <div className="description">
              Enable subscribers to add their own custom topics on the topic preferences page.
            </div>
            <ReactStrap.FormGroup check>
              <ReactStrap.Label check>
                <ReactStrap.Input 
                  type="checkbox" 
                  checked={this.getEnableCustomTopics()}
                  onChange={(e) => this.props.onChange(TopicPreferencesLayoutAttributes.EnableCustomTopics, e.target.checked)}
                />
                {' '}Enable custom topics input
              </ReactStrap.Label>
            </ReactStrap.FormGroup>
          </div>
        </div>

        <div className="section">
          <div className="block">
            <div className="title">Predefined Topics</div>
            <div className="description">
              Add topics that will be displayed to subscribers on the topic preferences page. These topics will appear in the "Recommended Topics" section.
            </div>
            
            {/* Add new topic */}
            <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
              <ReactStrap.Input
                type="text"
                placeholder="Enter topic name..."
                value={newTopicName}
                onChange={(e) => this.setState({ newTopicName: e.target.value })}
                onKeyPress={this.handleKeyPress}
                style={{ marginBottom: '1rem' }}
              />
              <div style={{ textAlign: 'center' }}>
                <ReactStrap.Button 
                  color="primary" 
                  onClick={this.handleAddTopic}
                  disabled={!newTopicName.trim()}
                >
                  Add Topic
                </ReactStrap.Button>
              </div>
            </div>

            {/* Display existing topics */}
            {communityTopics.length > 0 ? (
              <div>
                <h6>Current Topics ({communityTopics.length})</h6>
                <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '4px', padding: '0.5rem' }}>
                  {communityTopics.map((topic, index) => (
                    <div key={topic.id || index} style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center', 
                      padding: '0.5rem',
                      borderBottom: index < communityTopics.length - 1 ? '1px solid #f0f0f0' : 'none'
                    }}>
                      <span>{topic.name || topic.topic}</span>
                      <i 
                        className="fa fa-trash" 
                        style={{ 
                          color: '#dc3545', 
                          cursor: 'pointer', 
                          padding: '4px',
                          fontSize: '16px'
                        }}
                        onClick={() => {
                          if (window.confirm(`Are you sure you want to remove the topic "${topic.name || topic.topic}"?`)) {
                            this.props.onTopicRemove(topic.id)
                          }
                        }}
                        title="Remove topic"
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{ 
                padding: '2rem', 
                textAlign: 'center', 
                backgroundColor: '#f8f9fa', 
                borderRadius: '4px',
                color: '#6c757d'
              }}>
                <p>No predefined topics added yet.</p>
                <p><small>Add topics above to give subscribers recommended options.</small></p>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}